import styled from '@emotion/styled';

const ActionList = styled.div`
    display: flex;
    gap: 7px;

    button {
        white-space: nowrap;
    }
`;
export default ActionList;
